import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function locomotiva(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@locomotiva/FIND_VEICULO':
      case '@locomotiva/UPDATE_VEICULO':
      case '@locomotiva/DELETE_VEICULO':
      case '@locomotiva/STORE_VEICULO':
      case '@locomotiva/VEICULOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@locomotiva/SUCCESS_REMOVE':
      case '@locomotiva/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@locomotiva/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.veiculos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@locomotiva/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.veiculo;
        break;
      }

      case '@locomotiva/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
